export const EXSBOWNER_CREATE_RESET = 'EXSBOWNER_CREATE_RESET'
export const EXSBOWNER_CREATE_SET_CREATED = 'EXSBOWNER_CREATE_SET_CREATED'
export const EXSBOWNER_CREATE_SET_ERROR = 'EXSBOWNER_CREATE_SET_ERROR'
export const EXSBOWNER_CREATE_SET_VIOLATIONS = 'EXSBOWNER_CREATE_SET_VIOLATIONS'
export const EXSBOWNER_CREATE_TOGGLE_LOADING = 'EXSBOWNER_CREATE_TOGGLE_LOADING'
